module.exports = __webpack_public_path__ + "img/top_titlejz.1ac29fb1.png";